import { render, staticRenderFns } from "./EmptyMessage.vue?vue&type=template&id=3c8e6050&scoped=true&lang=pug&"
import script from "./EmptyMessage.vue?vue&type=script&lang=ts&"
export * from "./EmptyMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e6050",
  null
  
)

export default component.exports